
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1024 1024","fill":"currentColor","width":"1em","height":"1em"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M655.308 511.957l-47.529 51.88-356.508 371.356c-19.028 20.48-19.028 53.758 0 73.384 19.712 20.564 51.284 20.564 70.312 0l440.9-460.184c19.625-19.967 19.625-52.819 0-72.53l-440.9-460.44c-19.028-20.564-50.6-20.564-70.312 0-19.028 19.882-19.028 52.82 0 72.701L607.78 460.247l47.529 51.71z"}})])
          )
        }
      }
    